import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {dateFormat, dateFormatYYYYMMDD} from '../../constants/constants';
dayjs.extend(utc);

export const convertDateFormat = (date: string) => {
  return dayjs(date).format(dateFormat);
};

export const convertDateTimeToUTC = (date: Date) => {
  if (!date) return '';
  return dayjs.utc(date).format();
};

export const convertDateTimeToDate = (date: Date) => {
  if (!date) return '';
  return dayjs(date).format(dateFormatYYYYMMDD);
};
